<template>
  <resource-base
    :loading-display="false"
    :is-management-mode="isManagementMode"
    :resource="resource"
    :settings="settings"
    @settings-gen-changed="handleSettingsGenChange"
  >
    <template v-slot:display>
      <b-container>
        <display :resource="resource" @appLog="appLog" />
      </b-container>
    </template>
    <template v-slot:activity>
      <activity :resource="resource" />
    </template>
    <template v-slot:settings>
      <settings
        :resource="resource"
        :settings="settings"
        @resource-updated="handleRefreshResource"
        @settings-user-changed="handleSettingsUserChange"
      />
    </template>
  </resource-base>
</template>

<script>
import ResourceBase from "../resourceBase";
import Display from "./sections/display";
import Activity from "./sections/activity";
import Settings from "./sections/settings";
export default {
  name: "Resource_MatchGame",
  components: {
    ResourceBase,
    Display,
    Activity,
    Settings
  },
  props: {
    isManagementMode: {
      type: Boolean,
      default: false
    },
    resource: {
      type: Object,
      required: false,
      default: () => {}
    },
    settings: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  data() {
    return {
      show: false,
      title: this.resource.name,
      imgURL: this.resource.imgURL,
      faIcon: this.resource.icon ? this.resource.icon : "fa-folder"
    };
  },
  methods: {
    handleRefreshResource() {
      //console.log('refreshing resource');
      this.$emit("refresh-publishing");
    },
    showResource() {
      this.show = true;
    },
    appLog(data) {
      //Use Mixins
      this.$emit("appLog", data);
    },
    handleSettingsUserChange(settings) {
      //can be a mixin
      this.$emit("settings-user-changed", settings);
    },
    handleSettingsGenChange(settings) {
      //move to mixin
      this.$emit("settings-gen-changed", settings);
    }
  }
};
</script>

<style lang="scss">
img {
  cursor: pointer;
}
</style>
